import { Variants } from 'framer-motion'

interface IMotionAnimation {
  initial: string
  animate: string
  exit: string
  variants: Variants
}

export const motionGrowFadeIn = (duration: number): IMotionAnimation => ({
  initial: 'initial',
  animate: 'animate',
  exit: 'exit',
  variants: {
    initial: {
      opacity: -1,
      height: 0,
      overflow: 'hidden',
      transition: {
        ease: 'easeIn',
        duration
      }
    },
    animate: {
      opacity: 1,
      height: 'auto',
      overflow: 'hidden',
      transition: {
        ease: 'easeIn',
        duration
      }
    },
    exit: {
      opacity: -1,
      height: 0,
      overflow: 'hidden',
      transition: {
        ease: 'easeIn',
        duration
      }
    }
  }
})

export const motionFadeIn = (duration: number, delay = 0): IMotionAnimation => ({
  initial: 'initial',
  animate: 'animate',
  exit: 'exit',
  variants: {
    initial: {
      opacity: 0,
      transition: {
        ease: 'easeIn',
        duration,
        delay
      }
    },
    animate: {
      opacity: 1,
      transition: {
        ease: 'easeIn',
        duration,
        delay
      }
    },
    exit: {
      opacity: 0,
      transition: {
        ease: 'easeIn',
        duration,
        delay
      }
    }
  }
})

export const motionFadeInOnly = (duration: number, delay = 0): IMotionAnimation => ({
  initial: 'initial',
  animate: 'animate',
  exit: 'exit',
  variants: {
    initial: {
      opacity: 0,
      transition: {
        ease: 'easeIn',
        duration: 0,
        delay: 0
      }
    },
    animate: {
      opacity: 1,
      transition: {
        ease: 'easeIn',
        duration,
        delay
      }
    },
    exit: {
      opacity: 0,
      transition: {
        ease: 'easeIn',
        duration: 0,
        delay: 0
      }
    }
  }
})

export const motionSlideDownFadeIn = (duration: number): IMotionAnimation => ({
  initial: 'initial',
  animate: 'animate',
  exit: 'exit',
  variants: {
    initial: {
      opacity: 0,
      top: '-30px',
      position: 'relative',
      transition: {
        ease: 'easeIn',
        duration
      }
    },
    animate: {
      opacity: 1,
      top: '0px',
      position: 'relative',
      transition: {
        ease: 'easeIn',
        duration
      }
    },
    exit: {
      opacity: 0,
      top: '-30px',
      position: 'relative',
      transition: {
        ease: 'easeIn',
        duration
      }
    }
  }
})

export const GRID_CARDS_VARIANTS: Variants = {
  initial: {
    opacity: 0,
    transition: {
      duration: 0.05
    }
  },
  animate: {
    opacity: 1,
    transition: {
      staggerChildren: 0.075,
      staggerDirection: 1,
      duration: 0.05
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.05
    }
  }
}

export const GRID_CARD_VARIANTS: Variants = {
  initial: {
    opacity: 0,
    // transform: 'translatey(10px)',
    transition: {
      ease: 'easeInOut',
      duration: 0.35
    }
  },
  animate: {
    opacity: 1,
    // transform: 'translateX(0px)',
    transition: {
      ease: 'easeInOut',
      duration: 0.35
      // staggerChildren: 6
    }
  },
  exit: {
    opacity: 0,
    // transform: 'translateX(-10px)',
    transition: {
      ease: 'easeInOut',
      duration: 0.35
    }
  }
}
